// redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import modelReducer from './modelSlice';
import sidebarReducer from './sidebarSlice';
import sessionReducer from './sessionSlice';
import chatReducer from './chatSlice'; // 👈 Import chatSlice
import notificationReducer from "./notificationSlice";

export const store = configureStore({
  reducer: {
    model: modelReducer,
    sidebar: sidebarReducer,
    session: sessionReducer,
    chat: chatReducer, // 👈 Add it here
    notifications: notificationReducer, // 👈 Add notificationSlice
  },
});
